import { RootState } from "../../store";
import { CommitmentsInterface } from "../utils/types/types";

export const commitmentsSliceSelector = (
  state: RootState,
): CommitmentsInterface => {
  return state.commitments;
};
